import {
  ADD_ADMIN_ROLE_ERROR,
  ADD_ADMIN_ROLE_LOADING,
  ADD_ADMIN_ROLE_SUCCESS,
  ADD_ADMIN_ROLE,
  CLOSE_ADD_ROLE_MODAL,
  EMPTY_SELECTED_ROLE,
  FETCH_ALL_ROLES,
  FETCH_ALL_ROLES_SUCCESS,
  FETCH_ALL_ROLES_ERROR,
  FETCH_ALL_PERMISSIONS,
  FETCH_ALL_PERMISSIONS_ERROR,
  FETCH_ALL_PERMISSIONS_SUCCESS,
  OPEN_ADD_ROLE_MODAL,
  SELECT_ROLE,
  SHOW_MESSAGE,
  EMPTY_ROLE,
  EMPTY_ROLES,
  LOADING_ADD_ADMIN_ROLE,
} from "constants/ActionTypes";

export const fetchAllRoles = () =>
({
  type: FETCH_ALL_ROLES,
});

export const showRoleMessage = (message) => ({
  type: SHOW_MESSAGE,
  payload: message,
});
export const showRoleMessageError = (message) => ({
  type: SHOW_MESSAGE,
  payload: message,
});

export const fetchAllRolesResponse = (response) => {
  if (response.data && response.status === 200)
    fetchAllRolesSuccess(response.data);
  else
    return {
      type: FETCH_ALL_ROLES_ERROR,
      payload: response.data,
    };
};

export const fetchAllRolesSuccess = (response) => {
  // debugger
  if (typeof response === "undefined") return emptyRole();
  else if (response.data === null) {
    // debugger
    return emptyRole();
  } else if (response.state > 0 && response.data)
    return {
      type: FETCH_ALL_ROLES_SUCCESS,
      payload: response.data,
    };
  else return showUserMessage(response.msg);
};

// export const showUserMessage = (message) => ({
//     type: SHOW_MESSAGE,
//     payload: message,
//   }
// )
export const emptyRole = () => ({
  type: EMPTY_ROLE,
}
)

export const emptyRoles = () => ({
  type: EMPTY_ROLES
})

export const selectRole = (roleId) => ({
  type: SELECT_ROLE,
  payload: roleId,
});
export const emptySelectedRole = () => ({
  type: EMPTY_SELECTED_ROLE,
});
export const addAdminRole = ({ roleName, PermissionId = [] }) => {
  addAdminRoleLoading();
  return {
    type: ADD_ADMIN_ROLE,
    payload: { roleName, PermissionId },
  };
};
export const addAdminRoleSucess = (response) => ({
  type: ADD_ADMIN_ROLE_SUCCESS,
  payload: response,
});
export const addAdminRoleLoading = () => ({
  type: ADD_ADMIN_ROLE_LOADING,
});
export const addAdminRoleError = (message = "") => ({
  type: ADD_ADMIN_ROLE_ERROR,
  payload: message,
});

export const addAdminRoleResponse = (response) => {
  if (response.data && response.status === 200)
    return addAdminRoleSucess(response.data);
  else return addAdminRoleError("An error occurred in adding admin role");
};

export const fetchAllPermissions = () => ({
  type: FETCH_ALL_PERMISSIONS,
});

export const fetchAllPermissionsError = (message = "") => ({
  type: FETCH_ALL_PERMISSIONS_ERROR,
  payload: message,
});

export const fetchAllPermissionsSuccess = () => ({
  type: FETCH_ALL_PERMISSIONS_SUCCESS,
});

export const fetchAllPermissionsResponse = (response) => {
  if (response.data && response.status === 200)
    return fetchAllPermissionsSuccess(response.data);
  else
    return fetchAllPermissionsError("An error occurred in adding admin role");
};

export const openAddRoleModal = () => ({
  type: OPEN_ADD_ROLE_MODAL,
});

export const closeAddRoleModal = () => ({
  type: CLOSE_ADD_ROLE_MODAL,
});


export const loadingAddAdminRole = () => ({
  type: LOADING_ADD_ADMIN_ROLE,
});